(function () {
  'use strict';
  angular.module('benefits')
    .component('selectMember', {
        bindings: {
          refId: '=',
          expandAssociatedMembers: '='
        },
        controller: ['benefitService', 'localStorageService', 'historyService', '$uibModal', '$scope', function selectMemberController(benefitService,localStorageService,historyService,$uibModal, $scope) {
          var ctrl = this;
          ctrl.data = "Test Data"; 
          this.$onInit = function () {
            ctrl.isCollapsed = !ctrl.expandAssociatedMembers;

            ctrl.toggleSelectMemberBtn = function() {
              ctrl.isCollapsed = !ctrl.isCollapsed;
            };

            benefitService.getMemberByRefId(ctrl.refId).then(function (data) {
              ctrl.selectedMember = data;
            });
            benefitService.getMembers().then(function (data) {
              ctrl.members =  _.flatten(_.partition(data, function (m) {
                  return _.find(m.policies, (p) => {
                    return p.referenceId == ctrl.refId;
                  });
                }
              ));
            });
          };
          
        ctrl.selectMemebrModel = function(member,policy) {
          ctrl.modalOpen = true;
          ctrl.procedureCode = '';
          var modalInstance = $uibModal.open({
            templateUrl: '/js/benefits/selectMemberModal.html' + appVersion,
            controllerAs:'vm',
            controller: 'selectMemberModelController',
            size: 'md',
            animation: false,
            resolve:{
              member: function() {
                return member;
              },
	          policy: function() {
	            return policy;
	          }
            }
          });
          modalInstance.result.then(function(data) {
            ctrl.modalOpen = false;
          }, function() {
            ctrl.modalOpen = false;
          });
        }
        }],
        templateUrl: '/js/benefits/selectMember.html' + appVersion
      }
    );
})();
